module.exports = __webpack_public_path__ + "static/media/01C.567b9926.png";